import { Box } from "@material-ui/core";
import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { ExperiencesSearchControl } from "../../../search/components/ExperiencesSearchControl";
import { getLocation } from "../../../search/reducer/selectors";
import { getSelectedGroupedExperience } from "../../reducer/selectors";
import "./styles.scss";
import { AvailabilitySearchControlConnectorProps } from "./container";
import H from "history";

export interface IAvailabilitySearchControlProps
  extends AvailabilitySearchControlConnectorProps {
  history: H.History;
  scrolled?: any;
}

export const AvailabilitySearchControl = (
  props: IAvailabilitySearchControlProps
) => {
  const { scrolled } = props;

  const location = useSelector(getLocation);
  const selectedGroupedExperience = useSelector(getSelectedGroupedExperience);

  // Build initial text: "Category/Attraction - Destination" or just "Destination"
  const locationName = location?.label;
  const filterName = selectedGroupedExperience?.tag?.name;
  const initialText = filterName && locationName
    ? `${filterName} - ${locationName}`
    : locationName || undefined;

  return (
    <Box
      className={clsx("experiences-availability-search-container", {
        scrolled: scrolled,
      })}
    >
      <Box className="experiences-availability-search-control">
        <ExperiencesSearchControl
          displaySearchOnChangeOnly
          updateParamOnSearch
          hideTripDestinations
          combinedSearchPageContext="availability"
          combinedSearchInitialText={initialText}
          combinedSearchSelectedTag={selectedGroupedExperience?.tag}
        />
      </Box>
    </Box>
  );
};
